import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import SwitchRouter from "./SwitchRouter";
import { Redirect } from "react-router-dom";
import AuthorizedFunction from "config/AuthorizedFunction";
import Unauthorized from "components/shared/Unauthorized";
import TopNavbar from "../components/nav/TopNavbar";
import { Layout, message } from "antd";
// import { AppContext } from "contexts/AppContext";
import Sidebar from "./Sidebar";
import generalService from "../services/general.service";
import AuthService from "../services/auth.service";
import axios from "axios";
import { TOKEN_NAME, CANCEL_REQUEST } from "../constants";
import { setGlobalSetting } from "../redux/actions/app.action";
import { setAuthenticateUser } from "../redux/actions/auth.action";
import { useHistory } from "react-router-dom";

const { Content } = Layout;

const Main = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.authReducer);
  const [collapsed, setCollapsed] = useState(false);
  const [viewAthleteBar, setViewAthleteBar] = useState(false);
  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  useEffect(() => {
    // if (!isLoggedIn) {
    //   const token = localStorage.getItem(TOKEN_NAME);
    //   if (token) {
    //     AuthService.authenticateUser(token).then(
    //       (data) => {
    //         dispatch(setAuthenticateUser({ ...data, token: token }));
    //       },
    //       (error) => {
    //         if (error && error.message !== CANCEL_REQUEST) {
    //           message.error("API got error, please contact us.", 5);
    //         }
    //         console.log(error);
    //         return Promise.reject();
    //       }
    //     );
    //   } else {
    //     history.push("/login");
    //   }
    // }
  }, [isLoggedIn, dispatch]);

  return (
    <>
      {AuthorizedFunction(["user"]) ? (
        <Layout id="main">
          {/* <Sidebar collapsed={collapsed} onCollapse={onCollapse} /> */}
          <Layout
            className="site-layout"
            style={{ marginLeft: 0, minHeight: "100vh" }}
          >
            <TopNavbar setViewAthleteBar={setViewAthleteBar} />
            <Content className={viewAthleteBar ? "athlete-bar" : ""}>
              <div className="site-layout-content">
                <SwitchRouter />
              </div>
            </Content>
          </Layout>
        </Layout>
      ) : (
        <Unauthorized />
      )}
    </>
  );
};

// PullToRefresh.init({
//   mainElement: 'body',
//   onRefresh() {
//     window.location.reload();
//   }
// });

export default Main;
